/* ============================================================
   Olivia & Mary: single-item buy box in the product hero
   (snippets/olivia-buy-single.liquid), and "Show bundle" on the
   olivia-v2 hero (its picker, stock line, button and sticky bar).

   Picker, price, required size and the button itself are run by
   olivia-cro-pdp.js and product-form.js. This file only adds:
   - the few-left line, same pattern as the bundle: a number from
     1 to 8 per variant, drawn once per page view, sizes of one
     colour each a different number; not linked to Shopify stock;
   - the theme editor: hiding or showing the bundle section swaps
     between the bundle and this box without a page reload.
   ============================================================ */
(function () {
  'use strict';

  if (window.__oliviaBuySingleLoaded) return;
  window.__oliviaBuySingleLoaded = true;

  var MAX = 8;

  function readJSON(el) {
    try { return el ? JSON.parse(el.textContent) : null; } catch (error) { return null; }
  }

  function fill(template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function syncFallbacks() {
    document.querySelectorAll('[data-ol-buy-fallback]').forEach(function (el) {
      var root = el.dataset.olBuyFallbackFor ? document.getElementById(el.dataset.olBuyFallbackFor) : el.closest('[data-olivia-pdp]');
      el.hidden = !!(root && root.querySelector('[data-amelie-bundle-mount] > *'));
    });
  }
  window.oliviaSyncBuySingle = syncFallbacks;

  function FewLeft(box) {
    this.box = box;
    this.line = box.querySelector('[data-ol-few-left]');
    var root = box.closest('[data-olivia-pdp]');
    this.data = readJSON(root && root.querySelector('[data-olivia-product-data]'));
    if (!this.line || !this.data || !this.data.variants) return;
    this.input = box.querySelector('form[data-ol-form] input[name="id"]');
    var colors = String(box.dataset.colorNames || '').toLowerCase().split(',').map(function (name) { return name.trim(); });
    var names = (this.data.option_names || []).map(function (name) { return String(name || '').toLowerCase().trim(); });
    this.colorIndexes = names.map(function (name, index) { return colors.indexOf(name) !== -1 ? index : -1; }).filter(function (index) { return index !== -1; });
    var colorIndexes = this.colorIndexes;
    this.sizeIndex = names.findIndex(function (name, index) { return colorIndexes.indexOf(index) === -1 && /size/.test(name); });
    this.optionValues = names.map(function (name, index) {
      var seen = [];
      this.data.variants.forEach(function (variant) {
        var value = variant.options[index];
        if (value && seen.indexOf(value) === -1) seen.push(value);
      });
      return seen;
    }, this);
    this.draw();
    this.update();
  }

  FewLeft.prototype.draw = function () {
    var sizeIndex = this.sizeIndex;
    var groups = {};
    this.data.variants.forEach(function (variant) {
      var key = variant.options.filter(function (value, index) { return index !== sizeIndex; }).join('\u0000');
      (groups[key] = groups[key] || []).push(variant);
    });
    this.shown = {};
    var shown = this.shown;
    Object.keys(groups).forEach(function (key) {
      var pool = [];
      for (var n = 1; n <= MAX; n++) pool.push(n);
      for (var i = pool.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var swap = pool[i]; pool[i] = pool[j]; pool[j] = swap;
      }
      groups[key].forEach(function (variant, index) {
        shown[variant.id] = index < pool.length ? pool[index] : 1 + Math.floor(Math.random() * MAX);
      });
    });
  };

  /* "Navy Blue, size S": option values only; options with one value are left out. */
  FewLeft.prototype.name = function (variant) {
    var parts = [];
    var size = '';
    variant.options.forEach(function (value, index) {
      if (!value || (this.optionValues[index] || []).length < 2) return;
      if (index === this.sizeIndex) size = 'size ' + value;
      else parts.push(value);
    }, this);
    if (size) parts.push(size);
    return parts.join(', ');
  };

  /* Shown only for a complete, purchasable choice: olivia-cro-pdp.js enables
     the form's variant id exactly then. */
  FewLeft.prototype.update = function () {
    var line = this.line;
    var id = this.input && !this.input.disabled ? Number(this.input.value) : 0;
    var variant = id ? this.data.variants.filter(function (v) { return v.id === id; })[0] : null;
    if (!variant || !variant.available || !this.shown[variant.id]) {
      line.hidden = true;
      line.textContent = '';
      return;
    }
    var count = this.shown[variant.id];
    var name = this.name(variant);
    var box = this.box.dataset;
    var text = !name
      ? fill(box.stockSingle || 'Only [count] left', { count: count })
      : count === 1
        ? fill(box.stockOne || 'Only 1 left in [variant]', { count: count, variant: name })
        : fill(box.stockText || '[count] left in [variant]', { count: count, variant: name });
    var dot = document.createElement('span');
    dot.className = 'olivia-buy-single__dot';
    dot.setAttribute('aria-hidden', 'true');
    var label = document.createElement('span');
    label.textContent = text;
    line.replaceChildren(dot, label);
    line.hidden = false;
  };

  var lines = [];

  function init(scope) {
    (scope || document).querySelectorAll('[data-ol-buy-single]').forEach(function (box) {
      if (box.dataset.olSingleReady === 'true') return;
      box.dataset.olSingleReady = 'true';
      var few = new FewLeft(box);
      if (few.line && few.data) lines.push(few);
    });
  }

  function updateAll() {
    lines = lines.filter(function (few) { return few.box.isConnected; });
    lines.forEach(function (few) { few.update(); });
  }

  document.addEventListener('olivia:variant:change', function () { setTimeout(updateAll, 0); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) setTimeout(updateAll, 0); });

  function boot() {
    init(document);
    syncFallbacks();
    // olivia-cro-pdp.js may restore a remembered or ?variant= choice on boot.
    setTimeout(updateAll, 0);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor. A mounted bundle lives inside the hero, not in its own
     section, so hiding or removing that section must take the bundle out of
     the hero as well; then this box shows. */
  document.addEventListener('shopify:section:unload', function (event) {
    var id = event.detail && event.detail.sectionId;
    if (!id) return;
    ['AmelieBundle-' + id, 'GiftBox-' + id].forEach(function (elementId) {
      var mounted = document.getElementById(elementId);
      if (mounted && mounted.closest('[data-amelie-bundle-mount]')) mounted.remove();
    });
    setTimeout(syncFallbacks, 0);
  });
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    setTimeout(function () { syncFallbacks(); updateAll(); }, 0);
  });
})();
